import React, { CSSProperties } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import clsx from "clsx";

const useStylesCheckbox = makeStyles({
	root: {
		// "&:hover": {
		// 	backgroundColor: "transparent"
		// }
	},
	label: {
		// fontSize: "15px !important",
	},
	icon: {
		borderRadius: 2,
		width: 16,
		height: 16,
		boxShadow: "inset 0 0 0 1px var(--checkbox-border-color), inset 0 -1px 0 var(--checkbox-border-color)",
		// backgroundColor: "#f5f8fa",
		// backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
		// "$root.Mui-focusVisible &": {
		// 	outline: "2px auto rgba(19,124,189,.6)",
		// 	outlineOffset: 2
		// },
		"input:hover ~ &": {
			// backgroundColor: "#ebf1f5",
			boxShadow:
				"inset 0 0 0 1px var(--checkbox-border-color-hover), inset 0 -1px 0 var(--checkbox-border-color-hover)",
		},
		"input:disabled ~ &": {
			boxShadow: "none",
			background: "rgba(206,217,224,.5)",
		},
	},
	checkedIcon: {
		backgroundColor: "#1dafec",
		backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
		"&:before": {
			display: "block",
			width: 16,
			height: 16,
			backgroundImage:
				"url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
				" fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
				"1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
			content: '""',
		},
		"input:hover ~ &": {
			backgroundColor: "#1dafec",
		},
	},
});

export function UICheckbox(
	props: CheckboxProps & { label: string | React.ReactNode; labelClassName?: string; labelStyle?: CSSProperties }
) {
	const classes = useStylesCheckbox({});

	return (
		<FormControlLabel
			style={props.labelStyle}
			className={props.labelClassName}
			control={
				<Checkbox
					color="primary"
					size="small"
					className={classes.root}
					style={{ marginTop: "2px" }}
					// disableRipple
					// checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
					// icon={<span className={classes.icon} />}
					inputProps={{
						"aria-label": "Include Trial Level Output",
					}}
					{...props}
				/>
			}
			label={
				<span className="text-md text-gray d-inline-block" style={{ marginTop: "1px", marginLeft: "-3px" }}>
					{props.label}
				</span>
			}
		/>
	);
}
